import { NgModule } from '@angular/core';
import { BaseEducationDetailsLibraryService } from 'base-education-details-library';
import { EducationDetailsLibraryComponent } from './education-details-library.component';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import { DateFormatModule } from 'date-format';
import { EditorLibraryModule } from 'editor-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { ImportProfileDetailsModule } from 'import-profile-details';
import { EditEducationDetailsTabModule } from 'edit-education-details-tab';
//import { SimpleEducationDetailLibraryModule } from 'simple-education-detail-library';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { GenericBeneficiaryEducationModule } from 'generic-beneficiary-education';

@NgModule({
  declarations: [EducationDetailsLibraryComponent],
  imports: [
    PrimengLibraryModule,
    StepStatusUpdateComponentLibraryModule,
    DeleteDialogLibraryModule,
    SendBackComponentLibraryModule,
    NotificationComponentLibraryModule,
    DateFormatModule,
    EditorLibraryModule,
    LastUpdateLibraryModule,
    EditEducationDetailsTabModule,
    AssigningTaskLibraryModule,
    CustomQuestionnaireModule,
    MaximizeDialogLibraryModule,
    ImportProfileDetailsModule,
    MatButtonToggleModule,
    GenericBeneficiaryEducationModule
  ],
  providers:[BaseEducationDetailsLibraryService],
  exports: [EducationDetailsLibraryComponent]
})
export class EducationDetailsLibraryModule { }
